import styled from "@emotion/styled/macro";
import { useEffect, useState } from "react";
import Insurance from "./InsuranceCheck";
import ProofInsurance from "./ProofInsurance";
import Legal from "./Legal";
import { ContentLayout } from "../../components/ui/ContentLayout";
import CardView from "../../components/pageParts/Cards/CardView";
import { useTranslation } from "react-i18next";
import back from "../../assets/images/back.png";
import backMobile from "../../assets/images/backMobile.png";
import CmsService from "../../services/CmsService";
import Unavailble from "./Unavailable";
import { Box, Spinner } from "@chakra-ui/react";

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.powder};
  display: flex;
  flex-direction: column;
  background-repeat: no-repeat;
  background-position: top left;
  background-size: contain;
  background-image: url(${backMobile});

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    background-image: url(${back});
    background-size: auto;
    background-position: top -120px right -650px;
  }
`;

const CardWrapper = styled.div`
  margin: 3em 0;
`;

const SpinnerBox = styled(Box)`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    align-items: center;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 1em 2em;
    text-align: center;
    flex-direction: column;
  }
  margin: 4em 0;
  display: flex;
  justify-content: center;
`;

const Home = () => {
  const { i18n } = useTranslation();
  const [booleanCheck, setBooleanCheck] = useState();
  const [text, setText] = useState();
  const [unavailibility, setUnavailibility] = useState();
  const { language } = i18n;

  useEffect(() => {
    const fetchUnavailibility = async () => {
      const api = new CmsService();
      setUnavailibility(null);
      try {
        const booleanCheck = await api.getUnavailibility(
          language === "eng" ? `unavailabilities?_locale=en` : `unavailabilities?locale=${language}`
        );
        setUnavailibility(booleanCheck);
      } catch (e) {
        console.log(e);
        setUnavailibility(null);
      }
    };
    fetchUnavailibility();
  }, [language]);
  useEffect(() => {
    check(); // eslint-disable-next-line
  }, [unavailibility]);

  const check = () => {
    const today = new Date();
    const dateFrom = new Date(unavailibility?.unavailabilityStart);
    const dateTo = new Date(unavailibility?.unavailabilityStop);
    if (today.getTime() >= dateFrom.getTime() && today.getTime() <= dateTo.getTime()) {
      setBooleanCheck(false);
    } else {
      setBooleanCheck(unavailibility?.booleanCheck);
    }
    setText(unavailibility?.message);
  };

  const cards = ["abroad", "accident", "verification"];

  return (
    <Wrapper>
      <ContentLayout>
        {booleanCheck === undefined ? (
          <SpinnerBox>
            <Spinner size="xl" thickness="4px" />
          </SpinnerBox>
        ) : !booleanCheck ? (
          <Unavailble text={text} />
        ) : (
          <Insurance />
        )}
        <CardWrapper>
          <CardView cards={cards} />
        </CardWrapper>
      </ContentLayout>
      <ProofInsurance />
      <Legal />
    </Wrapper>
  );
};

export default Home;
